import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
import { observable } from 'mobx';
import { getOmniData, FeatureImgId, FeatureChannelId } from '@src/services/omni-api';
import Toast from '@src/components/toast';
import { useRequest } from 'ahooks';

import { useEffect } from 'react';
class FeatureStore {
  featureBaseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      ...swiperOptions.default,
      pagination: {
        el: '#main-group-24',
        type: 'bullets',
        clickable: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },

    }
  });

  page = 1;
  pageSize = 10;

  @observable featureImgList;

  getImgListAsync = () => {
    return getOmniData(FeatureChannelId, [
      {
        dataSourceId: FeatureImgId || '',
        page: this.page,
        perPage: this.pageSize
      }
    ])
      .then(res => {
        // console.log('222:', res);
        if (res[FeatureImgId].result?.items) {
          this.featureImgList = res[FeatureImgId].result?.items.map(item => {
            // console.log('item:', res[FeatureImgId].result?.items);
            return {
              // url: item.feature_img[0]?.url || '',
              url: item.preview[0]?.url || '',

              contentId: item.contentId || '',
              title: item.title || ''
            };
          });
        }
      })
      .catch(error => {
        Toast.fail(error?.msg);
      });
  };

  constructor(options = {}) {
    Object.assign(this, options);
  }

  use() {
    this.getImgListRequest = useRequest(
      async () => {
        await this.getImgListAsync();
      },
      { manual: true }
    );
    useMount(async () => {
      this.getImgListRequest.run();
    });
    useEffect(
      () => {
        if (!this.featureImgList || this.featureImgList.length === 0) {
          return;
        }

        // $$tracker.clickJhkbLunbotu(this.featureImgList[this.featureBaseSwiperStore.activeIndex]?.title);
      },
      [this.featureBaseSwiperStore.activeIndex, this.featureImgList]
    );
  }
}

export default FeatureStore;
